module.exports = __webpack_public_path__ + "img/rjc@2x.c78ca6b.webp";